// extracted by mini-css-extract-plugin
export default {"legal":"H02zPfuN"};